import { Link } from "react-router-dom";

/**
 * ModuleHeader — tasteful 240px photo strip used at the top of every module page.
 *
 * Props:
 *   title      {string}    — large heading (e.g. "Pantry, meals & groceries")
 *   subtitle   {string=}   — smaller line below the title
 *   image      {string}    — Unsplash (or any) URL for the background photo
 *   galleryImages {string[]=} — optional photo mosaic shown behind the overlay
 *   breadcrumb {string=}   — override the back-link label (default "← Dashboard")
 *   to         {string=}   — override the back-link path (default "/")
 *   children               — optional stat chips rendered bottom-right
 */
export default function ModuleHeader({
  title,
  subtitle,
  image,
  galleryImages = [],
  className = "",
  breadcrumb = "← Dashboard",
  to = "/app",
  children,
}) {
  const hasGallery = Array.isArray(galleryImages) && galleryImages.length > 1;

  return (
    <div
      className={`hm-module-header ${className}`.trim()}
      style={image ? { backgroundImage: `url(${image})` } : undefined}
      role="banner"
    >
      {hasGallery && (
        <div className="hm-module-header-gallery" aria-hidden="true">
          {galleryImages.slice(0, 8).map((src, index) => (
            <img key={`${src}-${index}`} src={src} alt="" />
          ))}
        </div>
      )}
      <div className="hm-module-header-overlay" aria-hidden="true" />
      <div className="hm-module-header-content">
        <div className="hm-module-header-top">
          <Link to={to} className="hm-module-breadcrumb">{breadcrumb}</Link>
          {children && (
            <div className="hm-module-header-stats">{children}</div>
          )}
        </div>
        <h1 className="hm-module-header-title">{title}</h1>
        {subtitle && (
          <p className="hm-module-header-subtitle">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
